import { call, put, all, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { get } from 'lodash';

import * as actions from './actions';
import * as types from '../types';

import axiosAdmin from '../../../services/axiosAdmin';

function* loginRequest({ payload }) {
  try {
    const response = yield call(axiosAdmin.post, '/usuario/autenticar', payload);

    yield put(actions.loginSucess({ ...response.data }));

    // toast.success('Login realizado com sucesso');

    axiosAdmin.defaults.headers.Authorization = `Bearer ${response.data.token}`;
  } catch (error) {
    // console.log('error: ', error);
    toast.error('Usuário ou senha inválido');

    yield put(actions.loginFailure());
  }
}

function persistRehydrate({ payload }) {
  const token = get(payload, 'auth.token');

  if (!token) return;

  axiosAdmin.defaults.headers.Authorization = `Bearer ${token}`;
}

export default all([
  takeLatest(types.LOGIN_REQUEST, loginRequest),
  takeLatest(types.PERSIST_REHYDRATE, persistRehydrate),
]);
